import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * An nile-heading element.
 *
 * @fires count-changed - Indicates when the count changes
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('nile-heading')
export class NileHeading extends LitElement {
  static override styles = css`
    :host {
      display: block;
      border: solid 1px gray;
      padding: 16px;
      font-size: var(--nile-type-scale-5);
      padding-bottom: var(--nile-spacing-1-x);      
    }

    :host([size='header-1']) {
      font-size: var(--nile-type-scale-5, 18px);
      font-weight: var(--nile-font-weight-bold, 600);
    }
  `;

  /**
   * Button Lab
   */
  @property()
  name = '';
  /**
   * Text Size
   */
  @property({ type: String, reflect: true }) size = 'header-1';

  // override render() {
  //   return html` <h1 class="nds--heading">${this.name}</h1> `;
  // }

  override render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nile-heading': NileHeading;
  }
}
